import z from "zod";

import { STACK_ALIGNS, STACK_GAPS } from "./constants";

export const stackDataSchema = z.object({
  gap: z.enum(STACK_GAPS).optional(),
  align: z.enum(STACK_ALIGNS).optional(),
});

export type StackDataProps = z.infer<typeof stackDataSchema>;
